import { render } from "./segments.vue?vue&type=template&id=90289914&scoped=true"
import script from "./segments.vue?vue&type=script&lang=js"
export * from "./segments.vue?vue&type=script&lang=js"

import "./segments.vue?vue&type=style&index=0&id=90289914&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90289914"]])

export default __exports__